import React from "react";
import colors from "../theme/colors";

// Statut réservation -> libellé + couleur (centralisé).
const STATUS = {
  CANCELLED: { label: "Annulée", color: colors.danger },
  CANCELLED_PROPIETARIO: { label: "Annulée", color: colors.danger },
  CONFIRMADA: { label: "Confirmée", color: colors.success },
  PAID: { label: "Payée", color: colors.success },
  UNAVAILABLE: { label: "Indisponible", color: colors.neutral },
  PROPIETARIO: { label: "Propriétaire", color: colors.neutral },
};

function StatusBadge({ status, style }) {
  if (!status) return null;
  const conf = STATUS[status] || { label: status, color: colors.warning };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 32,
        boxSizing: "border-box",
        padding: "0 14px",
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 600,
        color: colors.white,
        backgroundColor: conf.color,
        ...style,
      }}
    >
      {conf.label}
    </div>
  );
}

export default StatusBadge;
